var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},[_c('v-select',{staticClass:"no-margins",attrs:{"items":_vm.langs,"solo":"","flat":"","dense":"","hide-details":"","single-line":""},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }